<template>
    <div class="m_container">
        <!-- 登录 -->
        <template v-if="formType=== 'login'">
            <el-form
                v-if="formType==='login'"
                ref="lForm"
                :model="form"
                :rules="rules"
                class="login-form"
                label-position="left"
            >
                <div class="c-flex-ajcenter title_box">
                    <h3 class="title">{{ $t('login.title') }}</h3>
                    <LangSelect class="lang" />
                </div>

                <el-form-item prop="mobile">
                    <el-input
                        v-model="form.mobile"
                        name="mobile"
                        clearable
                        :placeholder="$t('login.mobile')"
                        @focus="scrollToTop"
                    >
                        <i slot="prefix" class="el-icon el-icon-mobile-phone" />
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        v-model="form.password"
                        :type="pwdType"
                        name="password"
                        :placeholder="$t('login.password')"
                        clearable
                        @focus="scrollToTop"
                        @keyup.enter.native="submitLogin"
                    >
                        <i slot="prefix" class="el-icon el-icon-lock" />
                        <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        :loading="loading"
                        size="medium"
                        type="primary"
                        style="width:100%;"
                        @click.native.prevent="submitLogin"
                    >{{ $t('login.loginIn') }}</el-button>
                </el-form-item>
            </el-form>
            <div class="textWrap">
                <p class="register" @click="changeFormType('register')">{{ $t('login.register') }}</p>
                <!-- <p>|</p>
                <p class="register" @click="changeFormType('password')">修改密码</p> -->
                <p>|</p>
                <p class="register" @click="changeFormType('reset')">{{ $t('login.reset') }}</p>
            </div>
        </template>

        <!-- 注册 -->
        <Register
            v-if="formType=== 'register'"
            @hancleChange="changeFormType"
            @submit="submitRegister"
        />

        <!-- 修改密码 -->
        <EditPassword
            v-if="formType=== 'password'"
            @hancleChange="changeFormType"
            @submit="submitPassword"
        />

        <!-- 重置密码 -->
        <ResetPassword
            v-if="formType=== 'reset'"
            @hancleChange="changeFormType"
            @submit="submitResetPassword"
        />

    </div>
</template>

<script>
import EditPassword from './component/editPassword'
import ResetPassword from './component/resetPassword'
import Register from './component/register'
import LangSelect from '@/components/LangSelect'
import { getTid, setTid, getSid, setSid } from '@/utils/cookies'
import { register, password, resetPassword } from '@/api/Auth'
const defaultSettings = require('../../settings.js')

export default {
    name: 'Login',
    components: { EditPassword, ResetPassword, Register, LangSelect },
    data() {
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                const msg = this.$store.getters.language === 'en' ? 'Please enter your mobile' : '请输入手机号'
                return callback(new Error(msg))
            } else {
                const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    const msg = this.$store.getters.language === 'en' ? 'Please enter your password' : '请输入正确的手机号'
                    return callback(new Error(msg))
                }
            }
        }
        const validatePass = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                const msg = this.$store.getters.language === 'en' ? 'The password must contain 6 to 16 characters' : '密码长度需6-16位'
                callback(new Error(msg))
            } else {
                callback()
            }
        }
        return {
            pageTitle: defaultSettings.title,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
            froms: '',
            formType: 'login',
            loading: false,
            pwdType: 'password',
            form: {
                mobile: '',
                password: ''
            },
            rules: {
                mobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
                password: [{ required: true, validator: validatePass, trigger: 'blur' }]
            }
        }
    },

    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            vm.froms = from.path
        })
    },

    created() {
        this.tid ? setTid(this.tid) : ''
        this.sid ? setSid(this.sid) : ''
    },

    methods: {
        scrollToTop(e) {
            e.target.scrollIntoView(true)
        },

        showPwd() {
            if (this.pwdType === 'password') {
                this.pwdType = ''
            } else {
                this.pwdType = 'password'
            }
        },

        changeFormType(type) {
            this.formType = type
            this.$nextTick(() => {
                this.$refs['lForm'] ? this.$refs['lForm'].clearValidate() : ''
                this.$refs['rForm'] ? this.$refs['rForm'].clearValidate() : ''
                this.$refs['pForm'] ? this.$refs['pForm'].clearValidate() : ''
            })
        },

        submitLogin() {
            this.$refs['lForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch('user/login', this.form)
                        .then(async() => {
                            this.$notify({
                                title: this.$t('Notification.suc_title'),
                                message: this.$t('Notification.suc_login_msg'),
                                type: 'success',
                                duration: 2000
                            })
                            this.loading = false
                            if (this.tid) {
                                await this.$store.dispatch('tougao/getTouGaoInfo', { id: this.tid })
                                this.$router.push({ path: this.froms, query: { tid: this.tid } })
                            }
                            if (this.sid) {
                                this.$router.push({ path: this.froms, query: { sid: this.sid } })
                            }
                        })
                        .catch(() => {
                            this.loading = false
                        })
                }
            })
        },

        submitRegister(data) {
            register(data).then(res => {
                if (res.code === 200) {
                    this.$notify({
                        title: '成功',
                        message: '成功注册',
                        type: 'success',
                        duration: 2000
                    })
                    setTimeout(() => {
                        this.changeFormType('login')
                    }, 1000)
                }
            })
        },

        submitPassword(data) {
            this.changeFormType('login')
            password(data).then(res => {
                this.$notify({
                    title: '成功',
                    message: '成功修改',
                    type: 'success',
                    duration: 2000
                })
                setTimeout(() => {
                    this.changeFormType('login')
                }, 1000)
            })
        },

        submitResetPassword(data) {
            console.log('submitResetPassword', data)
            resetPassword(data).then(res => {
                this.$notify({
                    title: '成功',
                    message: '成功重置',
                    type: 'success',
                    duration: 2000
                })
                setTimeout(() => {
                    this.changeFormType('login')
                }, 1000)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    background: #f5f5f5;

    .el-form{
        padding: 0;
        margin: 0 20px;

        .el-form-item{
            padding-left: 0;
        }

        .el-icon{
            display: inline-block;
            margin-top: 12px;
            margin-right: 8px;
            font-size: 16px;
        }

        .el-icon-view-actived{
            color: var(--color)
        }

        .form-item{
            display: flex;
            justify-content: space-between;
            align-items: center;

            .disabledBtn{
                background: #ccc;
                border-color: #ccc;
            }
        }
    }

    .title_box{
        padding: 50px 0;
        margin: 0 auto;

        .lang{
            transform:translate(10px,10px);
        }
    }

    .textWrap{
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        cursor: pointer;

        .register{
            color: var(--color);
            font-weight: bold;
        }

        p{
            padding: 0 10px;
        }
    }
}
/deep/ input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
  font-size: 12px;
}

/deep/ input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
  font-size: 12px;
}

/deep/ input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
  font-size: 12px;
}

/deep/ input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
  font-size: 12px;
}
</style>
